/* ============================================================
   Maison Atelier Premium — wishlist-page.js
   Render della pagina wishlist dai dati localStorage
   ============================================================ */
(function () {
  'use strict';
  var page = document.querySelector('[data-wishlist-page]');
  if (!page) return;
  var grid = page.querySelector('[data-wishlist-grid]');
  var empty = page.querySelector('[data-wishlist-empty]');
  var loading = page.querySelector('[data-wishlist-loading]');
  var Wishlist = window.theme && window.theme.Wishlist;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var renderId = 0;
  if (!grid || !Wishlist) return;

  function getHandles() {
    return Wishlist.get();
  }

  function showEmpty() {
    if (empty) empty.hidden = false;
    if (grid) grid.hidden = true;
    if (loading) loading.hidden = true;
  }

  function render() {
    var currentRender = ++renderId;
    var handles = getHandles();
    if (!handles.length) { showEmpty(); return; }

    if (empty) empty.hidden = true;
    if (grid) grid.hidden = false;
    if (loading) loading.hidden = false;
    grid.innerHTML = '';

    Promise.all(handles.map(function (handle) {
      return fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html.trim();
            return tmp.querySelector('[data-rv-card], .card');
          }
        })
        .catch(function () { return null; });
    })).then(function (cards) {
      if (currentRender !== renderId) return;
      cards.forEach(function (card, index) {
        if (card && Wishlist.has(handles[index])) grid.appendChild(card);
      });
      if (loading) loading.hidden = true;
      if (!grid.children.length) showEmpty();
      document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: grid } }));
    });
  }

  document.addEventListener('wishlist:updated', function (event) {
    if (!event.detail || !event.detail.handle || event.detail.added) { render(); return; }
    grid.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-wishlist-toggle') === event.detail.handle) {
        var card = btn.closest('.card');
        if (card) card.remove();
        if (grid && !grid.children.length) showEmpty();
      }
    });
  });

  render();
})();
